import React from 'react';

export const cashDeliveryConfig = [
  {
    path: '/order-cash-delivery-cit-maker',
    component: React.lazy(() => import('./listing/listing')),
  },
  {
    path: '/order-cash-delivery-cit-maker/add',
    component: React.lazy(() => import('./add/add')),
  },
  {
    path: '/order-cash-delivery-cit-maker/add-immediate',
    component: React.lazy(() => import('./addImmediate/add')),
  },
  {
    path: '/order-cash-delivery-cit-maker/edit',
    component: React.lazy(() => import('./edit/edit')),
  },
  {
    path: '/order-cash-delivery-cit-maker/edit-immediate',
    component: React.lazy(() => import('./editImmediate/edit')),
  },
  {
    path: '/order-cash-delivery-cit-maker/view',
    component: React.lazy(() => import('./overview/view')),
  },
  {
    path: '/order-cash-delivery-cit-maker/overview-immediate',
    component: React.lazy(() => import('./overviewImmediate/overview')),
  },
];
